import { ImageList } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import { SearchBar } from 'src/components/input';
import { sortAssetsByUploadDate } from 'src/hooks/api/assets/helper';
import { IAsset } from 'src/interfaces/Assets';

import {
  checkAssetMatch,
  filterAssetsBySearchName,
} from '../ResourceSelector.helper';
import { ResourceSelectorContentBodyProps } from './ResourceSelectorSidebar.interface';
import { ResourceSelectorContent } from './ResourceSelectorSidebar.styled';
import { ResourceSelectorSidebarItem } from './resourceSelectorSidebarItem';

export const ResourceSelectorContentBody: React.FC<
  ResourceSelectorContentBodyProps
> = ({
  assets,
  searchVal,
  isLoadingAssets,
  onChangeSearchVal,
  selectedAssets,
  onSelectedAssets,
  type,
  onChange,
  defaultAsset,
}: any) => {
  const defaultSelectedAsset = isEmpty(selectedAssets) ? defaultAsset : null;
  const filteredAssets = useMemo(() => {
    const sortedAssets = sortAssetsByUploadDate(assets);

    return filterAssetsBySearchName(sortedAssets, searchVal, type);
  }, [assets, searchVal, type]);

  return (
    <>
      <SearchBar
        value={searchVal}
        isLoading={isLoadingAssets}
        onInputChange={onChangeSearchVal}
      />

      <ResourceSelectorContent>
        <ImageList rowHeight={120} gap={6} cols={3}>
          {filteredAssets.map((asset: IAsset) => {
            const isSelected = checkAssetMatch(
              selectedAssets,
              asset,
              defaultSelectedAsset,
            );

            return (
              <ResourceSelectorSidebarItem
                type={type}
                key={asset.assetId}
                fileName={asset.fileName}
                src={asset.thumbnailUrl}
                isSelected={isSelected}
                onClick={() => {
                  onSelectedAssets([asset]);
                  onChange(asset.fileName);
                }}
              />
            );
          })}
        </ImageList>
      </ResourceSelectorContent>
    </>
  );
};
